/* eslint-disable */
/* tslint:disable */
/* Do not edit - generated by swagger-typescript-api */

import {
  Condition,
  ErrorResponse,
  Sorting,
  WarehouseResponseCollectionResponse,
} from './data-contracts';
import { HttpClient, RequestParams } from './http-client';
export class Warehouses<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;
  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Warehouses
   * @name WarehousesList
   * @request GET:/Warehouses
   * @response `200` `WarehouseResponseCollectionResponse` OK
   * @response `400` `ErrorResponse` The request was refused. Messages carries the text, Problems the structured rules that refused it.
   */
  warehousesList = (
    query?: {
      /** @format int32 */
      skip?: number;
      /** @format int32 */
      top?: number;
      inlineCount?: boolean;
      search?: string;
      sortings?: Sorting[];
      conditions?: Condition[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<WarehouseResponseCollectionResponse, ErrorResponse>({
      path: `/Warehouses`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
}
